import { Empty, Tag, Tooltip } from "antd";
import { AnimatePresence, motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useLayoutEffect, useRef, useState, useCallback } from "react";
import { createPortal } from "react-dom";
import { faClose, faListUl, faSearch, faSort, faXmark, faXmarkSquare, IconDefinition } from "@fortawesome/free-solid-svg-icons";

//STYLES
import { ContainerList, Pop } from "./style";

//APP
import { removerAcentos } from "../../../utils";

//COMPONENTS
import Carregando from "../loading";
import ButtonCustom from '../../ButtonCustom';
import { Render } from "../render";
import { TitleH2 } from '../titleH2';
import SvgTalhaoMemo from "../../svgTalhaoMemo";

//PROPS
interface Props {
    label: string;
    empty_placeholder?: string;
    icon?: IconDefinition | SVGAElement;
    value: string;
    onChange: React.Dispatch<React.SetStateAction<string>>;
    onChangeId?: React.Dispatch<React.SetStateAction<number | string>>;
    onChangeExtra?: React.Dispatch<React.SetStateAction<number | string | null>> | Function;
    items: any[];
    iconList?: string[];
    descricaoItem: string;
    idItem: string;
    extraItem?: string | string[];
    highlightItem?: string;
    highlightColor?: string;
    /**Palavra que será desconsiderada (não será exibida o highlight) */
    highlightException?: string[];
    disabled?: boolean;
    loading?: boolean;
    zIndex?: number;
    rule?: 'obrigatório' | 'opcional'
    topPopover?: number;
    leftPopover?: number;
    textTranform?: 'capitalize' | 'uppercase' | 'lowercase';
    show_svg?: boolean;
}

export const PopSelect: React.FC<Props> = ({ label, icon, value, empty_placeholder, onChange, items,
    descricaoItem, idItem, onChangeId, disabled, onChangeExtra, extraItem, loading, iconList, zIndex,
    rule, topPopover, leftPopover, textTranform, highlightItem, highlightException = [""], highlightColor, show_svg = true
}) => { //nosonar

    //STATES
    const [open_modal, setOpen_modal] = useState<boolean>(false);
    const [index_atual, setIndex_atual] = useState<number>(null);

    function obterCaminhoSvg(item: any[]) {

        let caminho = iconList || ['kml', 'coordenadas'];

        if (caminho.length === 1) {
            return item?.[caminho?.[0]]
        }
        if (caminho.length === 2) {
            return item?.[caminho?.[0]]?.[caminho?.[1]]
        }
        if (caminho.length === 3) {
            return item?.[caminho?.[0]]?.[caminho?.[1]]?.[caminho?.[2]]
        }
        if (caminho.length === 4) {
            return item?.[caminho?.[0]]?.[caminho?.[1]]?.[caminho?.[2]]?.[caminho?.[3]]
        }
        if (caminho.length === 5) {
            return item?.[caminho?.[0]]?.[caminho?.[1]]?.[caminho?.[2]]?.[caminho?.[3]]?.[caminho?.[4]]
        }

        return item?.['kml']?.['coordenadas']
    }

    useEffect(() => {
        if (value === '' || value === null) {
            setIndex_atual(null);
        }
    }, [value])


    const triggerRef = useRef<HTMLButtonElement>(null);

    return (
        <Pop
            ref={triggerRef}
            whileTap={{ scale: (open_modal || disabled) ? undefined : 0.98 }}
            onClick={disabled ? () => { } : () => { setOpen_modal(!open_modal) }}
            data-disabled={disabled}
            style={{ zIndex: zIndex }}
        >
            <div className="Pop__content">
                <span className="Pop__content__label">
                    {label} {rule ? <small className="Pop__content__label__rule">({rule})</small> : null}
                </span>
                <div className="Pop__content__selected">
                    {typeof icon === 'object'
                        ? <FontAwesomeIcon icon={(icon as IconDefinition) ?? faListUl} style={{ color: 'var(--text-color-light)', paddingRight: 3 }} />
                        : ((iconList && index_atual !== null) ? <SvgTalhaoMemo fill='#7b7b7b' coordinates={obterCaminhoSvg(items?.[index_atual ?? 0])} className='Pop__content__selected__icon_talhao' /> : <img src={icon} alt="" className="Pop__content__selected__icon" />) //nosonar
                    }
                    {(value !== null && value !== '')
                        ? value
                        : <span className="Pop__content__selected__empty">{empty_placeholder ?? 'Nada foi selecionado'}</span>
                    }
                </div>
            </div>

            <FontAwesomeIcon icon={faSort} className="Pop__iconDefault" />


            <ListPopOver
                title={label ?? 'Selecione'}
                open={open_modal}
                onClose={setOpen_modal}
                onChange={onChange}
                onChangeId={onChangeId}
                onChangeExtra={onChangeExtra}
                list_itens={items ?? []}
                descricaoItem={descricaoItem}
                idItem={idItem}
                extraItem={extraItem}
                selected={value}
                loading={loading}
                iconList={iconList}
                setIndex_atual={setIndex_atual}
                topPopover={topPopover}
                leftPopover={leftPopover}
                textTranform={textTranform}
                highlightItem={highlightItem}
                highlightColor={highlightColor}
                highlightException={highlightException}
                triggerRef={triggerRef}
                show_svg={show_svg}
            />
        </Pop>
    )
};

//PROPS LIST
interface PropsList {
    title: string;
    open: boolean;
    onClose: Function;
    onChange: React.Dispatch<React.SetStateAction<string>>;
    onChangeId?: React.Dispatch<React.SetStateAction<number | string>>;
    onChangeExtra?: React.Dispatch<React.SetStateAction<number | string | null>> | Function;
    list_itens: any[];
    descricaoItem: string;
    idItem: string;
    extraItem?: string | string[]
    selected: string;
    loading?: boolean;
    iconList?: string[];
    setIndex_atual?: Function;
    topPopover?: number;
    leftPopover?: number;
    triggerRef?: React.RefObject<HTMLButtonElement>;
    textTranform?: 'capitalize' | 'uppercase' | 'lowercase';
    highlightItem?: string;
    highlightColor?: string;
    /**Palavra que será desconsiderada (não será exibida o highlight) */
    highlightException?: string[];
    show_svg?: boolean;
}

const ListPopOver: React.FC<PropsList> = ({ open, onClose, onChange, list_itens, descricaoItem,
    idItem, onChangeId, selected, title, onChangeExtra, extraItem, loading, iconList, setIndex_atual,
    topPopover, leftPopover, textTranform, highlightItem, highlightColor, highlightException, triggerRef, show_svg = true }) => {

    //REFs
    const refPopSelect = useRef(null);

    //STATES
    const [buscar_na_lista, setBuscar_na_lista] = useState<string>('');
    const [posStyle, setPosStyle] = useState<React.CSSProperties>({});
    const [renderDelayed, setRenderDelayed] = useState<boolean>(false);

    const handleClickOutside: any = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (refPopSelect.current && !refPopSelect.current.contains(event.target)) {
            onClose(false);
            setBuscar_na_lista('');
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true)

        let timeout: NodeJS.Timeout;
        if (open) {
            timeout = setTimeout(() => {
                setRenderDelayed(true);
            }, 300);
        } else {
            setRenderDelayed(false);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside, true);
            if (timeout) clearTimeout(timeout);
        }
    }, [open]);

    // Calcula a posição do dropdown baseado no elemento trigger
    const calcularPosicao = useCallback(() => {
        if (!open || !triggerRef?.current) return;

        const triggerRect = triggerRef.current.getBoundingClientRect();
        const dropdownHeight = refPopSelect.current?.offsetHeight || 300;
        const dropdownWidth = 450;

        const espacoAbaixo = window.innerHeight - triggerRect.bottom;
        const espacoAcima = triggerRect.top;

        let top: number;
        let left: number = triggerRect.left + (leftPopover ?? -10);

        // Se não cabe abaixo, abre acima
        if (espacoAbaixo < dropdownHeight && espacoAcima > espacoAbaixo) {
            top = triggerRect.top - dropdownHeight - 5;
        } else {
            top = triggerRect.bottom + 5;
        }

        // Aplicar offset custom do topPopover
        if (topPopover != null) {
            top = triggerRect.top + topPopover;
        }

        // Garante que não saia pela direita
        if (left + dropdownWidth > window.innerWidth) {
            left = window.innerWidth - dropdownWidth - 10;
        }
        // Garante que não saia pela esquerda
        if (left < 5) {
            left = 5;
        }

        setPosStyle({ position: 'fixed', top, left, zIndex: 9999 });
    }, [open, triggerRef, topPopover, leftPopover]);

    useLayoutEffect(() => {
        calcularPosicao();
    }, [open, calcularPosicao]);

    // Recalcular ao scrollar ou redimensionar
    useEffect(() => {
        if (!open) return;
        const handleRepositionar = () => calcularPosicao();
        window.addEventListener('scroll', handleRepositionar, true);
        window.addEventListener('resize', handleRepositionar);
        return () => {
            window.removeEventListener('scroll', handleRepositionar, true);
            window.removeEventListener('resize', handleRepositionar);
        };
    }, [open, calcularPosicao]);

    function buscarItem(item_encontrar: string) {
        const chave_sem_acento = removerAcentos(item_encontrar)
        return function (item) {
            const item_sem_acento = removerAcentos(String(item?.[descricaoItem]))
            return item_sem_acento?.toLowerCase()?.includes(chave_sem_acento?.toLowerCase()) || !item_encontrar
        }
    }
    function obterExtraItem(item: any[]) {

        if (typeof extraItem === 'string') {
            return item?.[extraItem];
        }

        if (Array.isArray(extraItem)) {
            return extraItem.map((key) => item?.[key]);
        }
    };

    function obterCaminhoSvg(item: any[]) { //nosonar

        let caminho = iconList || ['kml', 'coordenadas'];

        if (caminho.length === 1) {
            return item?.[caminho?.[0]]
        }
        if (caminho.length === 2) {
            return item?.[caminho?.[0]]?.[caminho?.[1]]
        }
        if (caminho.length === 3) {
            return item?.[caminho?.[0]]?.[caminho?.[1]]?.[caminho?.[2]]
        }
        if (caminho.length === 4) {
            return item?.[caminho?.[0]]?.[caminho?.[1]]?.[caminho?.[2]]?.[caminho?.[3]]
        }
        if (caminho.length === 5) {
            return item?.[caminho?.[0]]?.[caminho?.[1]]?.[caminho?.[2]]?.[caminho?.[3]]?.[caminho?.[4]]
        }

        return item?.['kml']?.['coordenadas']
    }

    const dropdownContent = (
        <AnimatePresence>
            {open && (
                <ContainerList
                    initial={{ opacity: 0.5, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 60 }}
                    transition={{ duration: 0.5, ease: [0, 0.71, 0.2, 1.01], exit: { duration: 0.1, ease: [0, 1.21, 0.77, 0.91] } }}
                    onClick={(e) => e.stopPropagation()}
                    ref={refPopSelect}
                    style={posStyle}
                >
                    <div className='ContainerList__header'>
                        <TitleH2>{title}</TitleH2>
                        <ButtonCustom
                            icon={<FontAwesomeIcon icon={faClose} />}
                            onClick={() => { onClose(false); setBuscar_na_lista('') }}
                            danger
                            type="tertiary"
                        >
                            Fechar
                        </ButtonCustom>
                    </div>
                    <div className='newInputField'>
                        <FontAwesomeIcon icon={faSearch} className='newInputField__icon' />
                        <input
                            value={buscar_na_lista}
                            onChange={(e) => setBuscar_na_lista(e.currentTarget.value)}
                            placeholder='Buscar item na lista'
                            autoFocus
                        />
                        {buscar_na_lista !== '' && (
                            <button className='newInputField__close' onClick={() => setBuscar_na_lista('')}>
                                <FontAwesomeIcon icon={faClose} className='newInputField__close__icon' />
                            </button>
                        )}

                    </div>
                    <Render condition={!loading}>
                        <div className="ContainerList__list">
                            {(list_itens ?? []).filter(buscarItem(buscar_na_lista)).map((item, index) => {
                                let is_selecionado = selected === item?.[descricaoItem];
                                return (
                                    <Tooltip title={is_selecionado ? 'Clique para deselecionar!' : null} key={item?.[descricaoItem] + index}>
                                        <button
                                            className="ContainerList__list__item"
                                            tabIndex={index}
                                            onClick={is_selecionado ? () => {
                                                onChange('');
                                                onChangeId?.(null);
                                                onChangeExtra?.(null);
                                                onClose(false);
                                                setBuscar_na_lista('');
                                                setIndex_atual?.(null);
                                            }
                                                : () => {
                                                    onChange(item?.[descricaoItem]);
                                                    onChangeId?.(item?.[idItem]);
                                                    onChangeExtra?.(obterExtraItem(item));
                                                    onClose(false);
                                                    setBuscar_na_lista('');
                                                    setIndex_atual?.((list_itens ?? []).indexOf(item));
                                                }}
                                            // disabled={selected===item?.[descricaoItem]}
                                            data-active={is_selecionado}
                                        >
                                            <div className="ContainerList__list__item__content" style={{ textTransform: textTranform }}>

                                                <div className="ContainerList__list__item__circle" data-active={is_selecionado} />

                                                {item?.[descricaoItem]}

                                                {(highlightItem && !(highlightException.includes(item?.[highlightItem]))) && (
                                                    <Tag color={highlightColor ?? "green"} style={{ fontWeight: 500, fontFamily: 'Poppins', fontSize: 10 }}>
                                                        {(item?.[highlightItem])?.replace('talhao', 'talhão principal')}
                                                    </Tag>
                                                )}

                                            </div>

                                            {(show_svg && renderDelayed) &&
                                                <motion.div
                                                    initial={{ opacity: 0, x: 20, scale: 0.8 }}
                                                    animate={{ opacity: 1, x: 0, scale: 1 }}
                                                    transition={{ duration: 0.4, ease: "easeOut", delay: index * 0.03 }}
                                                >
                                                    <SvgTalhaoMemo
                                                        coordinates={obterCaminhoSvg(item)}
                                                        fill={selected === item?.[descricaoItem] ? "white" : "#5da57d"}
                                                        className="ContainerList__list__item__svg"
                                                    />
                                                </motion.div>
                                            }

                                            <FontAwesomeIcon icon={faXmark} className="ContainerList__list__item__close" />

                                        </button>
                                    </Tooltip>
                                )
                            })}
                        </div>
                    </Render>

                    <Render condition={loading}>
                        <Carregando
                            animation
                            legenda="Carregando..."
                            justifyContent="center"
                        />
                    </Render>

                    <Render condition={!loading && list_itens.length === 0}>
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Nenhum registro encontrado" />
                    </Render>

                </ContainerList>
            )}

        </AnimatePresence>
    );

    return createPortal(dropdownContent, document.body);
}